import parse from 'html-react-parser';
import type React from 'react';
import styled from 'styled-components';
import { adjustContentVisibility, Section } from '../Content';
import type { DefaultSectionProps } from '../DefaultSectionProps';
import { ProductCard, ProductsSectionTitle, ProductsSubtitle } from './components';
import type { Product } from './defaults';

export interface ProductsProps extends DefaultSectionProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly products: Product[];
  readonly trackingLabel?: string;
  readonly showDiamond?: boolean;
}

const OurProductsList = styled.ul<{ readonly productsQtt: number }>`
  display: flex;
  width: 100%;
  max-width: 1440px;
  align-items: space-between;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  max-width: 1440px;
  margin-top: 35px;
  gap: 30px;

  @media (max-width: 1430px) {
    max-width: ${({ productsQtt }) => `${productsQtt < 5 ? 1440 : 980}px`};
  }

  @media (max-width: 900px) {
    max-width: ${({ productsQtt }) => `${productsQtt < 5 ? 900 : 900}px`};
    margin-top: 30px;
  }
`;

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export const Products: React.FC<ProductsProps> = ({
  title,
  subtitle,
  products,
  trackingLabel,
  showDiamond = true,
  ...sectionProps
}) => {
  return (
    <StyledSection {...sectionProps} py={[40, 70]}>
      <ProductsSectionTitle tabIndex={0} withSubtitle={subtitle != null}>
        {parse(title)}
      </ProductsSectionTitle>
      {subtitle && <ProductsSubtitle showDiamond={showDiamond}>{subtitle}</ProductsSubtitle>}
      <OurProductsList productsQtt={products.length}>
        {products.map(product => (
          <ProductCard key={product.product} product={product} trackingLabel={trackingLabel} />
        ))}
      </OurProductsList>
    </StyledSection>
  );
};
